import { AddressGeoToken } from "./types";

export type AddressGeoApiType =
  | "country"
  | "FO"
  | "subject"
  | "district"
  | "city"
  | "street"
  | "house";

export type AddressGeoHierarchyEntry = {
  type: AddressGeoApiType;
  parentToken: AddressGeoToken | null;
};

export const ADDRESS_GEO_HIERARCHY: Record<
  AddressGeoToken,
  AddressGeoHierarchyEntry
> = {
  country: { type: "country", parentToken: null },
  fo: { type: "FO", parentToken: "country" },
  subject: { type: "subject", parentToken: "fo" },
  district: { type: "district", parentToken: "subject" },
  city: { type: "city", parentToken: "district" },
  locality: { type: "city", parentToken: "city" },
  street: { type: "street", parentToken: "locality" },
  house: { type: "house", parentToken: "street" },
};

export const ADDRESS_GEO_ORDER: AddressGeoToken[] = [
  "country",
  "fo",
  "subject",
  "district",
  "city",
  "locality",
  "street",
  "house",
];

export const getAddressGeoType = (token: AddressGeoToken): AddressGeoApiType =>
  ADDRESS_GEO_HIERARCHY[token].type;

export const getCanonicalParentToken = (
  token: AddressGeoToken,
): AddressGeoToken | null => ADDRESS_GEO_HIERARCHY[token].parentToken;
